// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { Options } from './Options.gen';
import type { PublicBranchOfficeControllerActivateBranchOfficeData } from './PublicBranchOfficeControllerActivateBranchOfficeData.gen';
import type { PublicBranchOfficeControllerActivateBranchOfficeErrors } from './PublicBranchOfficeControllerActivateBranchOfficeErrors.gen';
import type { PublicBranchOfficeControllerActivateBranchOfficeResponses } from './PublicBranchOfficeControllerActivateBranchOfficeResponses.gen';
import type { PublicBranchOfficeControllerCreateBranchOfficeData } from './PublicBranchOfficeControllerCreateBranchOfficeData.gen';
import type { PublicBranchOfficeControllerCreateBranchOfficeErrors } from './PublicBranchOfficeControllerCreateBranchOfficeErrors.gen';
import type { PublicBranchOfficeControllerCreateBranchOfficeResponses } from './PublicBranchOfficeControllerCreateBranchOfficeResponses.gen';
import type { PublicBranchOfficeControllerDeactivateBranchOfficeData } from './PublicBranchOfficeControllerDeactivateBranchOfficeData.gen';
import type { PublicBranchOfficeControllerDeactivateBranchOfficeErrors } from './PublicBranchOfficeControllerDeactivateBranchOfficeErrors.gen';
import type { PublicBranchOfficeControllerDeactivateBranchOfficeResponses } from './PublicBranchOfficeControllerDeactivateBranchOfficeResponses.gen';
import type { PublicBranchOfficeControllerGetAllData } from './PublicBranchOfficeControllerGetAllData.gen';
import type { PublicBranchOfficeControllerGetAllErrors } from './PublicBranchOfficeControllerGetAllErrors.gen';
import type { PublicBranchOfficeControllerGetAllResponses } from './PublicBranchOfficeControllerGetAllResponses.gen';
import type { PublicBranchOfficeControllerGetOneData } from './PublicBranchOfficeControllerGetOneData.gen';
import type { PublicBranchOfficeControllerGetOneErrors } from './PublicBranchOfficeControllerGetOneErrors.gen';
import type { PublicBranchOfficeControllerGetOneResponses } from './PublicBranchOfficeControllerGetOneResponses.gen';
import type { PublicBranchOfficeControllerUpdateBranchOfficeData } from './PublicBranchOfficeControllerUpdateBranchOfficeData.gen';
import type { PublicBranchOfficeControllerUpdateBranchOfficeErrors } from './PublicBranchOfficeControllerUpdateBranchOfficeErrors.gen';
import type { PublicBranchOfficeControllerUpdateBranchOfficeResponses } from './PublicBranchOfficeControllerUpdateBranchOfficeResponses.gen';
import type { PublicBranchOfficeControllerVerifyBranchNumberUniqueData } from './PublicBranchOfficeControllerVerifyBranchNumberUniqueData.gen';
import type { PublicBranchOfficeControllerVerifyBranchNumberUniqueErrors } from './PublicBranchOfficeControllerVerifyBranchNumberUniqueErrors.gen';
import type { PublicBranchOfficeControllerVerifyBranchNumberUniqueResponses } from './PublicBranchOfficeControllerVerifyBranchNumberUniqueResponses.gen';

export class PublicBranchOfficeController {
    /**
     * Get all branch offices
     */
    public static getAll<ThrowOnError extends boolean = false>(options?: Options<PublicBranchOfficeControllerGetAllData, ThrowOnError>) {
        return (options?.client ?? client).get<PublicBranchOfficeControllerGetAllResponses, PublicBranchOfficeControllerGetAllErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/branch-offices',
            ...options
        });
    }
    
    /**
     * Create a branch office.
     *
     * Require: `PERMISSION_BRANCH-OFFICES_EDIT`<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **BRANCH_NUMBER_NOT_UNIQUE** - A branch office with this number already exists.
     */
    public static createBranchOffice<ThrowOnError extends boolean = false>(options: Options<PublicBranchOfficeControllerCreateBranchOfficeData, ThrowOnError>) {
        return (options.client ?? client).post<PublicBranchOfficeControllerCreateBranchOfficeResponses, PublicBranchOfficeControllerCreateBranchOfficeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/branch-offices',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get branch office.
     *
     * Require: `PERMISSION_BRANCH-OFFICES_VIEW`
     */
    public static getOne<ThrowOnError extends boolean = false>(options: Options<PublicBranchOfficeControllerGetOneData, ThrowOnError>) {
        return (options.client ?? client).get<PublicBranchOfficeControllerGetOneResponses, PublicBranchOfficeControllerGetOneErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/branch-offices/{id}',
            ...options
        });
    }
    
    /**
     * Update a branch office.
     *
     * Require: `PERMISSION_BRANCH-OFFICES_EDIT`<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **BRANCH_NUMBER_NOT_UNIQUE** - A branch office with this number already exists.
     */
    public static updateBranchOffice<ThrowOnError extends boolean = false>(options: Options<PublicBranchOfficeControllerUpdateBranchOfficeData, ThrowOnError>) {
        return (options.client ?? client).put<PublicBranchOfficeControllerUpdateBranchOfficeResponses, PublicBranchOfficeControllerUpdateBranchOfficeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/branch-offices/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Verify branch number is unique.
     *
     * Require: `PERMISSION_BRANCH-OFFICES_VIEW`
     */
    public static verifyBranchNumberUnique<ThrowOnError extends boolean = false>(options: Options<PublicBranchOfficeControllerVerifyBranchNumberUniqueData, ThrowOnError>) {
        return (options.client ?? client).get<PublicBranchOfficeControllerVerifyBranchNumberUniqueResponses, PublicBranchOfficeControllerVerifyBranchNumberUniqueErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/branch-offices-check/{branchNumber}',
            ...options
        });
    }
    
    /**
     * Activate a branch office.
     *
     * Require: `PERMISSION_BRANCH-OFFICES_EDIT`<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **BRANCH_OFFICE_ALREADY_ACTIVATED** - Branch office is already activated.
     */
    public static activateBranchOffice<ThrowOnError extends boolean = false>(options: Options<PublicBranchOfficeControllerActivateBranchOfficeData, ThrowOnError>) {
        return (options.client ?? client).put<PublicBranchOfficeControllerActivateBranchOfficeResponses, PublicBranchOfficeControllerActivateBranchOfficeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/branch-offices/{id}/activate',
            ...options
        });
    }
    
    /**
     * Deactivate a branch office.
     *
     * Require: `PERMISSION_BRANCH-OFFICES_EDIT`<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **BRANCH_OFFICE_ALREADY_DEACTIVATED** - Branch office is already deactivated.<br>
     * + **COUNTER_CURRENTLY_USED** - Counter is currently used in a user shift or has active clearings.<br>
     * + **CLEARING_ACTION_FAILED** - Clearing action failed
     */
    public static deactivateBranchOffice<ThrowOnError extends boolean = false>(options: Options<PublicBranchOfficeControllerDeactivateBranchOfficeData, ThrowOnError>) {
        return (options.client ?? client).put<PublicBranchOfficeControllerDeactivateBranchOfficeResponses, PublicBranchOfficeControllerDeactivateBranchOfficeErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/branch-offices/{id}/deactivate',
            ...options
        });
    }
}
